<template>
  <div>
    <el-row class="form-item form-item-desc">
      <el-col :span="3">
        <span class="required-text">*</span>订单描述
      </el-col>
      <el-col :span="10">
        <el-input placeholder="请填写订单描述" style="width: 350px" v-model="orderDesc" @change="setDesc" maxlength="20"></el-input>
      </el-col>
    </el-row>
    <el-row class="form-item">
      <el-col>订单信息</el-col>
      <el-col v-if="orderMenuList.length">
        <el-table :data="orderMenuList" class="order-data-table ie-table">
          <el-table-column label="图片" width="85">
            <template slot-scope="scope">
              <div class="item-image">
                <img :src="getImageUrl(scope.row.pocmDTO)" />
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="pocmDTO.itemName" label="名称">
            <template slot-scope="scope">
              <div class="item-name">{{ scope.row.pocmDTO.itemName }}</div>
            </template>
          </el-table-column>
          <el-table-column label="品牌">
            <template slot-scope="scope">
              {{
              getBrandName(scope.row)
              }}
            </template>
          </el-table-column>
          <el-table-column label="工厂" prop="companyEntityName" />
          <el-table-column label="MMR12" prop="mmr12" width="50" />
          <el-table-column label="供应商" prop="pocmDTO.produceSupplierName" show-overflow-tooltip />
          <el-table-column label="价格(不含税)">
            <template slot-scope="scope">
              <div>￥{{ getPrice(scope.row.pocmDTO) | thousandSymbol}}</div>
              <div class="price-msg" v-if="scope.row.pocmDTO.priceUnitQuantity !== 1">
                (每{{ scope.row.pocmDTO.priceUnitQuantity }}个商品{{
                getPrice(scope.row.pocmDTO)
                }}元)
              </div>
            </template>
          </el-table-column>
          <el-table-column label="税额">
            <template slot-scope="scope">
              <div v-if="scope.row.pocmDTO.pocmPriceType === '01'">￥{{ getTaxPrice(scope.row.pocmDTO) | thousandSymbol}}</div>
              <div v-else>￥ 0.00</div>
              <div
                class="price-msg"
                v-if="
                  scope.row.pocmDTO.priceUnitQuantity !== 1 &&
                    scope.row.pocmDTO.pocmPriceType === '01'
                "
              >
                (每{{ scope.row.pocmDTO.priceUnitQuantity }}个商品{{
                getTaxPrice(scope.row.pocmDTO)
                }}元)
              </div>
            </template>
          </el-table-column>
          <el-table-column label="运费" prop="pocmDTO.extraFee">
            <template slot-scope="scope">
              <div>
                <!-- ￥{{ scope.row.pocmDTO.extraFee }} -->
                ￥{{ getExtraFee(scope.row) | thousandSymbol}}
              </div>
              <!-- <div class="price-msg" v-if="scope.row.pocmDTO.priceUnitQuantity !== 1 && scope.row.pocmDTO.extraFee !== 0">(每{{ scope.row.pocmDTO.priceUnitQuantity }}个商品{{ scope.row.pocmDTO.extraFee }}元)</div> -->
              <div
                class="price-msg"
                v-if="
                  scope.row.pocmDTO.priceUnitQuantity !== 1 &&
                    scope.row.pocmDTO.extraFee !== 0
                "
              >
                (每{{ scope.row.pocmDTO.priceUnitQuantity }}个商品{{
                getExtraFee(scope.row)
                }}元)
              </div>
            </template>
          </el-table-column>
          <el-table-column label="起订量" prop="pocmDTO.factoryMOQ" width="50" >
            <template slot-scope="scope">{{ scope.row.pocmDTO.factoryMOQ | thousandSymbol}}</template>
          </el-table-column>
          <el-table-column label="数量" prop="itemQuantity" width="60">
            <template slot-scope="scope">{{ scope.row.itemQuantity | thousandSymbol}}</template>
          </el-table-column>
          <!-- <el-table-column label="数量" width="100">
            <template slot-scope="scope">
              <el-input-number v-model="scope.row.itemQuantity" size="mini" :min="1" disabled />
            </template>
          </el-table-column>-->
          <el-table-column label="价格小计" width="80">
            <template slot-scope="scope">￥{{ getItemSumPrice(scope.row) | thousandSymbol}}</template>
          </el-table-column>
          <el-table-column label="税额小计" width="80">
            <template slot-scope="scope">￥{{ getItemSumTaxPrice(scope.row) | thousandSymbol}}</template>
          </el-table-column>
          <el-table-column label="运费小计" width="80">
            <template slot-scope="scope">
              <!-- {{ getItemSumExtraPrice(scope.row) }} -->
              ￥{{ getAllExtraFee(scope.row) | thousandSymbol}}
            </template>
          </el-table-column>
          <el-table-column label="是否库存化" min-width="100" v-if="showItemStockColumn">
            <template slot-scope="scope">
              <el-switch
                v-if = "showItemStock(scope.row)"
                v-model="scope.row.subjectCategory"
                @change="
                  changeSubjectCategory(
                    scope.$index,
                    scope.row.subjectCategory,
                    'menu'
                  )
                "
                active-value=""
                inactive-value="Z"
                active-text="是"
                inactive-text="否"
                active-color="#13ce66"
                inactive-color="#ff4949"
              >
              </el-switch>
            </template>
          </el-table-column>
        </el-table>
      </el-col>

      <el-col v-if="orderPrintList.length">
        <div v-for="(item, index) in orderPrintList" :key="index">
          <div class="order-print-table">
            <div>
              <div class="item-image">
                <img :src="getImageUrl(item.pocmDTO)" />
              </div>
            </div>
            <div>
              <div class="text-red">{{ item.pocmDTO.itemName }}</div>
              <div>物料编码：{{ item.pocmDTO.itemCode }}</div>
              <div>品牌：{{ item.abiBrandName }}-{{ item.subAbiBrandName }}</div>
              <div>渠道：{{ item.pocmDTO.channel }}</div>
              <div class="item-company" :title="item.companyEntityName">工厂：{{ item.companyEntityName }}</div>
              <!-- <div>分类：{{ item.pocmDTO.itemCategory.categoryName }}</div> -->
              <div>分类：{{ item.pocmDTO.secondCatalogueName }}</div>
              <div>供应商：{{ item.pocmDTO.produceSupplierName }}</div>
            </div>
            <div>
              <div>制作周期：{{ item.pocmDTO.productTime }}天</div>
              <div>物流周期：{{ item.pocmDTO.deliveryTime }}</div>
              <div v-if="item.pocmDTO.itemPrintsDTO">
                <div>材质要求：{{ item.pocmDTO.itemPrintsDTO.materialSpecs }}</div>
                <div>印刷要求：{{ item.pocmDTO.itemPrintsDTO.printSpecs }}</div>
                <div>覆膜方式：{{ item.pocmDTO.itemPrintsDTO.filmMulch }}</div>
                <div>印刷方式：{{ item.pocmDTO.itemPrintsDTO.printMethod }}</div>
                <div>模切要求：{{ item.pocmDTO.itemPrintsDTO.dieCutting }}</div>
              </div>
              <div v-else>
                <div>材质要求：</div>
                <div>印刷要求：</div>
                <div>覆膜方式：</div>
                <div>印刷方式：</div>
                <div>模切要求：</div>
              </div>
            </div>
            <div>
              <div class="prints-img">
                <el-upload
                  ref="upload"
                  :action="fileUploadTarget"
                  :before-upload="checkBeforeUpload"
                  :on-success="handleImgSuccess"
                  :on-remove="confirmImgRemove"
                  :on-exceed="handleExceed"
                  :headers="uploadHeaders"
                  :accept="'image/*'"
                  list-type="picture"
                  :file-list="imageList"
                  multiple
                >
                  <el-button class="btn-blue-plain" size="mini" @click="handleUpload(index)">上传预览图片</el-button>
                </el-upload>
              </div>
              <div>
                <span class="list-text">AI文件百度云链接：</span>
                <el-input size="mini" v-model="item.printsFileUri"></el-input>
              </div>
              <div>
                <span class="list-text">商品备注：</span>
                <el-input size="mini" v-model="item.detailRemark"></el-input>
              </div>
            </div>
            <div>
              <div>单价(不含税)：￥{{ getPrice(item.pocmDTO) | thousandSymbol}}</div>
              <div class="price-msg" v-if="item.pocmDTO.priceUnitQuantity !== 1">
                (每{{ item.pocmDTO.priceUnitQuantity | thousandSymbol}}个商品{{
                getPrice(item.pocmDTO) | thousandSymbol
                }}元)
              </div>
              <div>
                税额：
                <span v-if="item.pocmDTO.pocmPriceType === '01'">￥{{ getTaxPrice(item.pocmDTO) | thousandSymbol}}</span>
                <span v-else>￥ 0.00</span>
              </div>
              <div
                class="price-msg"
                v-if="
                  item.pocmDTO.priceUnitQuantity !== 1 &&
                    item.pocmDTO.pocmPriceType === '01'
                "
              >
                (每{{ item.pocmDTO.priceUnitQuantity | thousandSymbol}}个商品{{
                getTaxPrice(item.pocmDTO) | thousandSymbol
                }}元)
              </div>
              <div>运费：￥{{ item.pocmDTO.extraFee | thousandSymbol}}</div>
              <div
                class="price-msg"
                v-if="
                  item.pocmDTO.priceUnitQuantity !== 1 &&
                    item.pocmDTO.extraFee !== 0
                "
              >
                (每{{ item.pocmDTO.priceUnitQuantity | thousandSymbol}}个商品{{
                item.pocmDTO.extraFee
                }}元)
              </div>
              <div>
                数量：
                <el-input-number v-model="item.itemQuantity" size="mini" :min="1" disabled />
              </div>
              <div>
                价格小计：
                <span class="text-red">￥{{ getItemSumPrice(item) | thousandSymbol}}</span>
              </div>
              <div>
                税额小计：
                <span class="text-red">￥{{ getItemSumTaxPrice(item) | thousandSymbol }}</span>
              </div>
              <div>
                运费小计：
                <!-- <span class="text-red">￥{{ getItemSumExtraPrice(item) }}</span> -->
                <span class="text-red">￥{{ getAllExtraFee(item) | thousandSymbol}}</span>
              </div>
              <div class="print-proof">
                是否需要打样:
                <el-radio-group>
                  <el-radio-group v-model="item.isProof">
                    <el-radio :label="1">是</el-radio>
                    <el-radio :label="0">否</el-radio>
                  </el-radio-group>
                </el-radio-group>
              </div>
              <div class="print-proof" v-if="showItemStock(item)">
                是否库存化:
                <el-switch
                  v-model="item.subjectCategory"
                  @change="changeSubjectCategory(index, item.subjectCategory)"
                  active-value=""
                  inactive-value="Z"
                  active-text="是"
                  inactive-text="否"
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                >
                </el-switch>
                <!-- <el-radio-group>
                  <el-radio-group v-model="item.subjectCategory">
                    <el-radio :label="1">是</el-radio>
                    <el-radio :label="0">否</el-radio>
                  </el-radio-group>
                </el-radio-group> -->
              </div>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
    <slot></slot>
    <el-row class="form-item order-price">
      <el-col :span="5">订单明细</el-col>
      <el-col :span="5">
        <p v-if="Number(getFreightFreezer)">冰柜运费：￥{{ getFreightFreezer | thousandSymbol}}</p>
        <p v-if="Number(getFreightMenu)">POCM运费：￥{{ getFreightMenu | thousandSymbol}}</p>
        <p v-if="Number(getFreightMenu)" class="freight-hint">{{ `未税总额的${freightRatio * 100}%` }}</p>
      </el-col>
      <el-col :span="5" class="price-row">
        <div>商品件数：{{ itemAmout | thousandSymbol}}件</div>
        <div>商品总价：￥{{ totalPrice | thousandSymbol}}</div>
        <div>
          应支付金额：
          <span class="text-red">￥{{ payPrice | toFixed(2) | thousandSymbol}}</span>
        </div>
      </el-col>
      <el-col :span="5">
        <div class="price-box">
          <div>当前可使用预算</div>
          <div>￥{{ getBudget | thousandSymbol}}</div>
        </div>
      </el-col>
      <el-col :span="4">
        <div class="price-box">
          <div>本月已使用运费</div>
          <div>￥{{ monthExtraFee | thousandSymbol}}</div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { commonUtils } from '@/utils/common'
import { create, all } from 'mathjs/number'
import { mapState, mapGetters } from 'vuex'
import { tokenUtils } from '@/utils/auth'
import baseApi from '@/api/base'
import orderApi from '@/api/order'
const math = create(all)
export default {
  props: {
    orderItemList: {
      type: Array,
      default: () => {
        return []
      }
    },
    isUrgent: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      orderMenuList: [],
      orderPrintList: [],
      freightMenuList: [], // 一般menu物料
      freightFreezerList: [], // 冰柜
      radio: '',
      budget: 0,
      imageList: [],
      itemIndex: null,
      orderDesc: '',
      sdList: [],
      sdCode: '',
      monthExtraFee: ''
    }
  },
  computed: {
    ...mapState({
      fileUploadTarget: state => state.app.fileUploadTarget
    }),

    ...mapGetters(['userInfo']),

    uploadHeaders () {
      return {
        Authorization: 'Bearer ' + tokenUtils.getToken(true),
        Accept: 'application/json'
      }
    },

    // 运费比例
    freightRatio () {
      return this.isUrgent ? 0.13 : 0.1
    },

    // 冰柜运费 冰柜数量*运费 总和
    getFreightFreezer () {
      let price = 0
      if (this.freightFreezerList.length) {
        this.freightFreezerList.forEach(item => {
          const rowPriceSum = Number(
            math
              .multiply(
                item.itemQuantity / item.pocmDTO.priceUnitQuantity,
                item.pocmDTO.extraFee
              )
              .toFixed(2)
          )
          price += rowPriceSum
        })
      }
      price = Number(price)
        ? Number(commonUtils.formatNumber(price)).toFixed(2)
        : 0
      return price
    },

    // POCM运费 （普通Menu商品数量*未税价格的总和）*占比
    getFreightMenu () {
      let num = 0
      if (this.freightMenuList.length) {
        this.freightMenuList.forEach(item => {
          if (item.pocmDTO.extraFee) {
            const rowPriceSum = Number(
              math
                .multiply(
                  item.itemQuantity / item.pocmDTO.priceUnitQuantity,
                  item.pocmDTO.taxExcludedPrice
                )
                .toFixed(2)
            )
            num += rowPriceSum
          }
        })
      }
      let price = Number(num) * this.freightRatio
      price = Number(price)
        ? Number(commonUtils.formatNumber(price)).toFixed(2)
        : 0
      return price
    },

    // 商品总价 新逻辑：含税价/未税价*数量总和
    totalPrice () {
      let price = 0
      this.orderItemList.forEach(item => {
        // 根据上架类型 含税/未税 取价格
        let itemPrice =
          item.pocmDTO.pocmPriceType === '02'
            ? item.pocmDTO.taxExcludedPrice
            : item.pocmDTO.purchasePrice
        // 单行价格
        const rowPriceSum = Number(
          math
            .multiply(
              item.itemQuantity / item.pocmDTO.priceUnitQuantity,
              itemPrice
            )
            .toFixed(2)
        )

        price += rowPriceSum
      })

      price = Number(price)
        ? Number(commonUtils.formatNumber(price)).toFixed(2)
        : 0
      return price
    },

    // 应支付金额 新逻辑：冰柜运费+POCM运费+商品总价
    payPrice () {
      return (
        Number(this.totalPrice) +
        Number(this.getFreightFreezer) +
        Number(this.getFreightMenu) || 0
      )
    },

    // 总数
    itemAmout: function () {
      let total = 0
      this.orderItemList.forEach(item => {
        total = total + item.itemQuantity
      })
      return total
    },

    // // 商品总价
    // totalPrice: function () {
    //   let price = 0
    //   this.orderItemList.forEach(item => {
    //     let itemPrice = item.pocmDTO.purchasePrice// 含税价格
    //     if (item.pocmDTO.pocmPriceType === '02') itemPrice = item.pocmDTO.taxExcludedPrice// 未税价格
    //     const rowPriceSum = Number(math.multiply(item.itemQuantity / item.pocmDTO.priceUnitQuantity, itemPrice).toFixed(2))// 单行价格
    //     const rowExtraSum = Number(math.multiply(item.itemQuantity / item.pocmDTO.priceUnitQuantity, item.pocmDTO.extraFee).toFixed(2)) // 单行运费
    //     const rowPrice = math.add(rowPriceSum, rowExtraSum)
    //     price = math.add(price, rowPrice)
    //     price = Number(price) ? Number(commonUtils.formatNumber(price)).toFixed(2) : 0.01
    //   })
    //   return price
    // },

    // 应支付金额
    // payPrice: function () {
    //   if (this.isUrgent) {
    //     return this.totalPrice * this.$store.state.order.increase
    //   } else {
    //     return this.totalPrice
    //   }
    // },

    // 获取预算
    getBudget: function () {
      return this.$store.state.cart.budget
    },
    showItemStockColumn () {
      let show = false
      if (this.orderMenuList.length) {
        this.orderMenuList.forEach(item => {
          show = show || this.showItemStock(item)
        })
      }
      return show
    }
  },
  watch: {
    orderItemList () {
      this.classifyItem()
    },
    getBudget (val) {
      this.budget = val
    }
  },
  created () {
    this.classifyItem()
    this.getMonthExtraFee()
  },
  methods: {
    // 单个商品的运费
    getExtraFee (item) {
      let price = 0
      // 为pocm商品
      if (this.freightMenuList.indexOf(item) !== -1 && Number(item.pocmDTO.extraFee) > 0) {
        price = Number(item.pocmDTO.taxExcludedPrice) * this.freightRatio
      }
      // 为冰柜商品
      if (this.freightFreezerList.indexOf(item) !== -1) {
        price = Number(item.pocmDTO.extraFee)
      }

      price = Number(price)
        ? Number(commonUtils.formatNumber(price)).toFixed(2)
        : 0
      return price
    },
    // 运费小计的运费
    getAllExtraFee (item) {
      let price = 0
      // 为pocm商品
      if (this.freightMenuList.indexOf(item) !== -1 && Number(item.pocmDTO.extraFee) > 0) {
        price =
          Number(
            math
              .multiply(
                item.itemQuantity / item.pocmDTO.priceUnitQuantity,
                item.pocmDTO.taxExcludedPrice
              )
              .toFixed(2)
          ) * this.freightRatio
      }
      // 为冰柜商品
      if (this.freightFreezerList.indexOf(item) !== -1) {
        price = Number(
          math
            .multiply(
              item.itemQuantity / item.pocmDTO.priceUnitQuantity,
              item.pocmDTO.extraFee
            )
            .toFixed(2)
        )
      }

      price = Number(price)
        ? Number(commonUtils.formatNumber(price)).toFixed(2)
        : 0
      return price
    },
    // 额外费用合计
    getItemSumExtraPrice (item) {
      if (!item) {
        return ''
      }
      item.sumPrice = commonUtils
        .formatNumber(
          math.multiply(
            item.pocmDTO.extraFee,
            item.itemQuantity / item.pocmDTO.priceUnitQuantity
          )
        )
        .toFixed(2)
      item.sumPrice = Number(item.sumPrice)
      return item.sumPrice
    },
    // 税额小计
    getItemSumTaxPrice (item) {
      if (item.pocmDTO.pocmPriceType === '02') return 0
      let taxPrice = commonUtils
        .formatNumber(
          math.multiply(item.pocmDTO.taxRate, item.pocmDTO.taxExcludedPrice)
        )
        .toFixed(2)
      let price = commonUtils
        .formatNumber(
          math.multiply(
            taxPrice,
            item.itemQuantity / item.pocmDTO.priceUnitQuantity
          )
        )
        .toFixed(2)
      if (Number(price) < 0.01) price = 0.0
      return price
    },
    // 小计
    getItemSumPrice (item) {
      if (!item) {
        return ''
      }
      let price = item.pocmDTO.taxExcludedPrice
      // if (item.pocmDTO.pocmPriceType === '02') price = item.pocmDTO.taxExcludedPrice
      let sum = commonUtils
        .formatNumber(
          math.multiply(
            item.itemQuantity / item.pocmDTO.priceUnitQuantity,
            price
          )
        )
        .toFixed(2)
      sum = Number(sum)
      return sum
    },

    // 订单描述
    setDesc () {
      this.$emit('setDesc', this.orderDesc)
    },

    // 区分商品类型
    classifyItem () {
      this.orderPrintList = []
      this.orderMenuList = []
      this.freightMenuList = []
      this.freightFreezerList = []

      this.orderItemList.forEach(item => {
        if (item.pocmDTO.isPrints) {
          this.orderPrintList.push(item)
        } else {
          this.orderMenuList.push(item)
        }

        // 运费相关物料
        let categoryCode = item.pocmDTO.itemCategory.categoryCode || ''
        if (
          categoryCode &&
          categoryCode !== 'prints' &&
          categoryCode !== 'lybg'
        ) {
          // 普通menu商品
          this.freightMenuList.push(item)
        } else if (categoryCode === 'lybg') {
          // 冰柜
          this.freightFreezerList.push(item)
        }
      })
    },

    // 上传前检测
    checkBeforeUpload (file) {
      if (file.type.substr(0, 5) !== 'image') {
        this.$message.error('上传的文件不是图片文件，请重新上传')
        return false
      }
    },

    // 上传图片成功
    handleImgSuccess (res) {
      if (res.resultCode === '0') {
        this.$message.success('上传图片成功')
        this.orderPrintList[this.itemIndex].printsFiles.push(
          res.resultData.fileDTO.fileId
        )
      }
    },

    handleUpload (index) {
      this.itemIndex = index
    },

    // 删除图片
    confirmImgRemove (file) {
      if (
        file &&
        file.response &&
        file.response.resultData &&
        file.response.resultData.fileDTO
      ) {
        const fileId = file.response
          ? file.response.resultData.fileDTO.fileId
          : file.imageFileId
        baseApi.deleteFile({ fileId: fileId }).then(res => {
          if (res.data.resultCode === '0') {
            this.$message.warning('删除图片成功')
            this.orderPrintList.forEach(item => {
              item.printsFiles.forEach((pic, index) => {
                if (pic === fileId) {
                  item.printsFiles.splice(index, 1)
                }
              })
            })
          }
        })
      }
    },

    // 当月已使用额外费用合计
    getMonthExtraFee () {
      orderApi.getMonthExtraFee().then(res => {
        if (res.data.resultCode === '0') {
          this.monthExtraFee = res.data.resultData.sumExtraAmount
        }
      })
    },

    getPrice (item) {
      if (!item.taxExcludedPrice) return
      // 不含税价
      return item.taxExcludedPrice.toFixed(2)
    },
    // 计算税额
    getTaxPrice (item) {
      return (item.taxRate * item.taxExcludedPrice).toFixed(2)
    },

    handleExceed () { },

    getImageUrl (item) {
      let imageUri = ''
      if (item.imageList && item.imageList.length > 0) {
        imageUri = item.imageList[0].imageFileUri
      }
      return commonUtils.getImageUrl(imageUri)
    },

    getBrandName (row) {
      return row.subAbiBrandName
        ? row.abiBrandName + ' - ' + row.subAbiBrandName
        : row.abiBrandName
    },
    getChannelName (row) {
      if (row.subChannelName) {
        return row.channelName + ' - ' + row.subChannelName
      }
      return row.channelName
    },
    changeSubjectCategory (index, val, type) {
      if (val.toString() === 'true') val = ''
      if (type === 'menu') {
        this.orderMenuList[index].subjectCategory = val
      } else {
        this.orderPrintList[index].subjectCategory = val
      }
    },
    showItemStock (item) {
      const allowedCompanys = ["CN68", "CNJ0"]
      const allowedMmr12s = ["450", "451"]
      if (!item || !item.companyCode || !item.mmr12) {
        return false
      }
      return allowedCompanys.indexOf(item.companyCode.toUpperCase()) > -1 && allowedMmr12s.indexOf(item.mmr12) > -1
    }
  }
}
</script>

<style lang="scss" scoped>
.form-item {
  padding: $content-large;
  .order-print-table {
    width: 100%;
    margin-top: 5px;
    box-sizing: border-box;
    display: flex;
    border: 1px solid $base-grey5;
    border-radius: 5px;
    & > div {
      line-height: 1.5;
      box-sizing: border-box;
      padding: $content-middle;
      &:nth-child(1) {
        width: 10%;
      }
      &:nth-child(2) {
        width: 23%;
        border-right: 1px solid $base-grey5;
      }
      &:nth-child(3) {
        width: 19%;
        border-right: 1px solid $base-grey5;
      }
      &:nth-child(4) {
        width: 29%;
        border-right: 1px solid $base-grey5;
      }
      &:nth-child(5) {
        width: 19%;
      }
      & > div {
        margin-bottom: 10px;
      }
    }
    .item-image {
      width: 72px;
      height: 72px;
      margin: 0 auto;
      border: 1px solid $base-grey;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 5px;
    }
    .list-text {
      padding-bottom: 5px;
      display: inline-block;
    }
  }
}
.order-price {
  background-color: #ffd6e8;
  padding: $content-large;
  height: 130px;
  .price-row {
    div {
      margin-bottom: 10px;
      .text-red {
        font-weight: bold;
        color: $base-red;
        font-size: 16px;
      }
    }
  }
  .price-box {
    width: 200px;
    height: 75px;
    box-sizing: border-box;
    padding-top: 14px;
    line-height: 25px;
    text-align: center;
    border-radius: 6px;
    border: 1px dashed rgba(0, 0, 0, 0.15);
  }
}
.text-right {
  text-align: left !important;
}
.item-company {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.item-image {
  img {
    max-width: 90%;
    max-height: 90%;
  }
}
.form-item-desc {
  line-height: 50px;
}
.price-msg {
  margin-top: -6px;
}
.price-info {
  font-size: 12px;
  color: #999;
}
.freight-hint {
  font-size: 12px;
  color: #999;
  margin-top: -10px;
}
</style>
